module.exports = __webpack_public_path__ + "static/media/home_nav_logo.7e661e3f.svg";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/home_nav_logo.svg
// module id = 416
// module chunks = 0